import {MapControl} from "./MapControl";


const mapControl=new MapControl();

